<template>
	<div>
		<div class="modal fade" id="agregarProductosModal" tabindex="-1" role="dialog" aria-labelledby="agregarProductosModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document" style="width:900px" >
        <div 
          class="modal-content text-center"
          style="width: 100%; max-width: 100%"
        >
          <div class="modal-header">
            <h5 class="modal-title" id="agregarProductosModalLabel">Agregar productos al cupón</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
					<div class="modal-body">         
            <!---------------------NAV TABS------------------------>            
						<nav class="border border-primary rounded-top">
							<div class="nav nav-tabs" id="nav-tab" role="tablist">																		
								<a
									class="col col-sm-3 nav-item nav-link active"
									id="categorias-tab"
									data-toggle="tab"
									href="#categorias-content"
									role="tab"
									aria-controls="nav-home"
									aria-selected="true"
								>				
									<i class="fa fa-folder"></i>		
									<br>			
									Categorias	
								</a>								
								<a
									class="col col-sm-3 nav-item nav-link"
									id="subcategorias-tab"
									data-toggle="tab"
									href="#subcategorias-content"
									role="tab"
									aria-controls="subcategorias-home"
									aria-selected="true"
								>
									<i class="fa fa-list"></i>
									<br>
									Subcategorias
								</a>		
								<a
									class="col col-sm-3 nav-item nav-link"
									id="proveedores-tab"
									data-toggle="tab"
									href="#proveedores-content"
									role="tab"
									aria-controls="proveedores-home"
									aria-selected="true"
								>
									<i class="fa fa-truck"></i>
									<br>
									Proveedores
								</a>									
							</div>
						</nav>
						<div class="tab-content" id="nav-tabContent">
							<div
								class="tab-pane fade show active "
								id="categorias-content"
								role="tabpanel"
								aria-labelledby="nav-home-tab"
							>
								<!------------------------CONTENIDO DE CATEGORIAS---------------------------->              
								<div class="flex-shrink-0 mx-2 pr-2 mt-3" style="max-height: 100%; 
									width:100%"
								>								
									<div class="input-group mb-3 pr-2">
										<input type="text"
											class="form-control "
											placeholder="Busca por nombre o codigo de categoria"
											v-model="searchQuery"
											@input="onSearchInputCategoria"                    
										>
										<div class="input-group-append">
											<button class="btn"
												style="background-color:transparent;"
												v-if="searchQuery.length>0"
											>
												<i class="fa fa-times"
													@click="limpiarInput()"
												>
												</i>
											</button>
											<button class="btn btn-success"
												@click=onSearchInputCategoria
											>
												<i class="fa fa-search"></i>
											</button>
										</div>
									</div>						
									<div class="mt-2 border" style="max-height: 550px; overflow-y:auto">  
										<!----------------- tabla------------------ -->
										<table class="table table-striped table-hover"> 
											<tbody>
												<template v-for="cat in categoriasBusqueda">												
													<tr 																								
														v-if="cat.estado_agregado == 'NA'"
													>
														<td style="width:30%">
															{{ cat.codigo }} 
														</td>
														<td class="text-left">
															{{ cat.nombre }}
														</td>
														<td class="text-center">
															<button class="btn btn-success"
																@click="agregarCategoria(cat)">
																<i class="fa fa-plus"></i>
															</button>   
														</td>
													</tr>
												</template> 
											</tbody>
										</table>
										<!----------------- tabla------------------ -->                
									</div>                
								</div> 
							</div>
							<!-------------------fin contenido de CATEGORIA---------------->
							<div
								class="tab-pane fade "
								id="subcategorias-content"
								role="tabpanel"
								aria-labelledby="nav-home-tab"
							>
								<!------------------------ CONTENIDO SUB CATEGORIAS---------------------------->  
								<h5 class="text-center" v-if="subcategoriasList.length===0">
									Cargando...
								</h5>          
								<div class="flex-shrink-0 mx-2 pr-2 mt-3" style="max-height: 100%;
									width:100%" 
								>									
									<div class="input-group mb-3 pr-2">
										<input type="text"
											class="form-control"
											placeholder="Busca por nombre o codigo de subcategoria"
											v-model="searchQuerySubcategoria"
											@input="onSearchInputSubcategoria"    								 
											ref="inputSubcategoria"           
										>
										<div class="input-group-append">
											<button class="btn"
												style="background-color:transparent;"
												v-if="searchQuerySubcategoria.length>0"
											>
												<i class="fa fa-times"
													@click="limpiarInput()"
												>
												</i>
											</button>
											<button class="btn btn-success"
												@click="onSearchInputSubcategoria"									   
												ref="inputSubcategoria"
											>
												<i class="fa fa-search"></i>
											</button>
										</div>
									</div>  
									<div class="mt-2 border" style="max-height: 550px; overflow-y:auto">  
										<table class="table table-striped table-hover" v-if="subcategoriasList.length>0">                    
											<tbody>
												<template v-for="subcat in subcategoriasBusqueda">
													<tr v-if="subcat.estado_agregado =='NA'">
														<td style="width:30%">
															{{ subcat.codigo }} 
														</td>
														<td class="text-left">
															{{ subcat.nombre }}
														</td>
														<td class="text-center">
															<button class="btn btn-success"
																@click="agregarSubcategoria(subcat)">
																<i class="fa fa-plus"></i>
															</button>   
														</td>
													</tr>
												</template> 
											</tbody>
										</table>
									</div>
								</div> 
								<!-----------------------fin contenido de subcategorias--------------------->
							</div>
							<div
								class="tab-pane fade "
								id="proveedores-content"
								role="tabpanel"
								aria-labelledby="nav-home-tab"
							>
								<!------------------------ CONTENIDO PROVEEDORES---------------------------->				  				
								<h5 class="text-center" v-if="proveedoresList.length===0">
									Cargando...
								</h5>          
								<div class="flex-shrink-0 mx-2 pr-2 mt-3" style="max-height: 100%;
									width:100%" 
								>		
									<div class="input-group mb-3 pr-2">
										<input type="text"
											class="form-control"
											placeholder="Busca por nombre o codigo de proveedor"
											v-model="searchQueryProveedor"
											@input="onSearchInputProveedor"
											ref="inputProveedor"
										>
										<div class="input-group-append">
											<button class="btn"
												style="background-color:transparent;"
												v-if="proveedorSeleccionado.length>0"
											>
												<i class="fa fa-times"
													@click="limpiarInput()"
												>
												</i>
											</button>
											<button class="btn btn-success"
												@click="onSearchInputProveedor"								    
												ref="inputProveedor"
											>
												<i class="fa fa-search"></i>
											</button>
										</div>
									</div>  
									<div class="mt-2" style="max-height: 550px; overflow-y:auto"> 			
										<!-----------------------ACORDEON PROVEEDORES----------------------------------------->
										<table class="table table-striped table-hover" v-if="proveedoresList.length>0">                    
											<tbody>
												<template v-for="prov in proveedoresBusqueda">
													<tr v-if="prov.estado_agregado=='NA'">
														<td class=""
															style="width:20%"
															@click="abrirAcordeon(prov)"
														>
															{{ prov.codigo }} 
														</td>
														<td class="text-left "
															@click="abrirAcordeon(prov)"
														>
															{{ prov.nombre }}
														</td>
														<td class="text-center ">
															<button class="btn btn-success"
																@click="agregarProveedor(prov)">
																<i class="fa fa-plus"></i>
															</button>   
														</td>
													</tr> 
													<!--------------------------SUBTABLA--------------------------------------------->											
													<tr style="width:100%" 													
														class="no-hover"
														v-if="proveedorSeleccionado ===prov.codigo"
														:ref="'acorden-'+prov.codigo"
													>
														<td class="">
														</td>
														<td 
															class="mx-0 my-0 px-0 py-0"
														>
															<div class="">
																<nav class="border border-primary rounded-top">
																	<div class="nav nav-tabs" id="nav-tab" role="tablist">														
																		<a
																			class="col col-sm-3 nav-item nav-link active"
																			id="categorias-tab"
																			data-toggle="tab"
																			href="#categorias-subtab-content"
																			role="tab"
																			aria-controls="nav-home"
																			aria-selected="true"
																		>
																			Categorias
																		</a>
																		<a
																			class="col col-sm-3 nav-item nav-link"
																			id="subcategorias-tab"
																			data-toggle="tab"
																			href="#subcategorias-subtab-content"
																			role="tab"
																			aria-controls="nav-home"
																			aria-selected="true"
																			>Subcategorias</a
																		>
																	</div>
																</nav>
																<div class="tab-content" id="nav-tabContent">
																	<div
																		class="tab-pane fade show active "
																		id="categorias-subtab-content"
																		role="tabpanel"
																		aria-labelledby="nav-home-tab"
																	>
																		<table class="table table-hover  border rounded"
																			style="width:100%; "
																		>
																			<template v-for="cat in categoriasProveedor">
																				<tr v-if="cat.estado_agregado=='NA'">																	
																					<td class="text-right">
																						{{ cat.codigo }}
																					</td>
																					<td class="text-left">
																						&nbsp;
																						&nbsp;
																						&nbsp;
																						&nbsp;
																						&nbsp;
																						{{ cat.nombre  }}
																					</td>
																					<td class="text-right">
																						<button class="btn btn-success"
																							@click="agregarCategoriaProveedor(cat)"
																						>
																							<i class="fa fa-plus">
																							</i>
																						</button>
																					</td>
																				</tr>
																			</template>
																		</table>
																	</div>
																	<div
																		class="tab-pane fade"
																		id="subcategorias-subtab-content"
																		role="tabpanel"
																		aria-labelledby="nav-home-tab"
																	>
																		<table class="table table-hover"
																			style="width:100%"
																		>
																			<template v-for="subcat in subcategoriasProveedor">
																				<tr v-if="subcat.estado_agregado=='NA'">
																					<td class="text-right">
																						{{ subcat.codigo }}
																					</td>
																					<td class="text-left">
																						&nbsp;
																						&nbsp;
																						&nbsp;
																						&nbsp;
																						&nbsp;
																						{{ subcat.nombre  }}
																					</td>
																					<td class="text-right">
																						<button class="btn btn-success"
																							@click="agregarSubcategoriaProveedor(subcat)"
																						>
																							<i class="fa fa-plus">
																							</i>
																						</button>
																					</td>
																				</tr>
																			</template>
																		</table>												
																	</div>
																</div>	
															</div>																					
														</td>			
													</tr>
													<!----------------------fin subtabla----------------------------------->
												</template> 
											</tbody>
										</table>
										<!----------------------------fin acordeon proveedores-------------------------------->
									</div>
								</div> 
								<!-----------------------fin contenido proveedores--------------------->
							</div>
						</div>
					</div>      
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>            
          </div>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
	import DynamicService from "@/services/commons/DynamicService";
	import {debounce} from 'lodash'
	import Notifications from "@/notifications/notifications";
	
	export default{
		components:{
			DynamicService,
		},
		props: ["cuponera"],
		data(){
			return{
				searchQuery:'',
				categoriaSeleccionada:{},			
				buscarCategoriasDebounce:null,
				searchQuerySubcategoria:'',
				searchQueryProveedor:'',
				categoriasList:[],
				categoriasBusqueda:[],
				subcategoriasList:[],
				subcategoriasBusqueda:[],
				proveedoresList:[],
				proveedoresBusqueda:[],
				categoriasProveedor:[],
				subcategoriasProveedor:[],
				proveedorSeleccionado:""				
			}
		},
		watch:{ 
      searchQuery(val){
        if(val===''){                    
          this.getCategorias()
        }
      },
			// tipoSelected(val){
		
			// },
			cuponera(val){		
				if(val && val!==null){
					this.getCategorias()
					this.getSubcategorias()
					this.getProveedores()
				}
			}
		},		
		created(){
      this.buscarCategoriasDebounce = debounce(this.buscarCategorias,300)
      this.buscarSubcategoriasDebounce = debounce(this.buscarSubcategorias,300)
	  	this.buscarProveedoresDebounce = debounce(this.buscarProveedores,300)
    },
		methods:{   
			getCategorias(){
        let self=this;   				
				let params = {
					cuponera: this.cuponera
				}
        DynamicService.getActionList("cat", "categoria", "get_categorias", params)
        .then((response)=>{       					
          self.categoriasList=response.data.sort((a,b)=>{
						  if (a.codigo < b.codigo) return -1
							if (a.codigo > b.codigo) return 1							
							return 0							
					})
					//Asignacion de lista secundaria, el valor de la totalidad de las subcategorias
					self.categoriasBusqueda = self.categoriasList					  
        }).catch((error)=>{
          Notifications.alert.error(
            "Error al cargar categorías",
            error.response.data.error
          )
        })
      },
			getSubcategorias(){
				let self=this;
				let params = {
					cuponera: this.cuponera
				}
				DynamicService.getActionList("cat", "subcategoria", "get_subcategorias", params)
        .then((response)=>{          
          self.subcategoriasList=response.data.sort((a,b)=>{
						  if (a.codigo < b.codigo) return -1
							if (a.codigo > b.codigo) return 1
							
							return 0							
					})
					//Asignacion de lista secundaria, el valor de la totalidad de las subcategorias
					self.subcategoriasBusqueda = self.subcategoriasList					      
				}).catch((error)=>{
					Notifications.alert.error(
						"Error al cargar subcategorías",
						error.response.data.error
					)					  
        })
			},
			getProveedores(){
				let self=this;							
				let params = {
					cuponera: this.cuponera
				}
				DynamicService.getActionList("cat", "proveedores", "get_proveedores", params)
        .then((response)=>{         					
          self.proveedoresList=response.data.sort((a,b)=>{
						  if (a.codigo < b.codigo) return -1
							if (a.codigo > b.codigo) return 1							
							return 0							
					})					
					self.proveedoresBusqueda = self.proveedoresList					     
				}).catch((error)=>{
					Notifications.alert.error(
						"Error al cargar los proveedores",
						error.response.data.error
					)					  
        })
			},
			onSearchInputCategoria(){
        this.buscarCategoriasDebounce(this.searchQuery)
      },
			onSearchInputSubcategoria(){
        this.buscarSubcategoriasDebounce(this.searchQuerySubcategoria)
      },
			onSearchInputProveedor(){
				this.buscarProveedoresDebounce(this.searchQueryProveedor)
			},
			buscarCategorias(texto){
				let self=this;      
				let categoriasFiltradas = []  

				if(texto.length==0){ 									
					self.categoriasBusqueda = self.categoriasList
					return;
				}
				if(texto.length>=1 && texto.length<3){ 					
					self.categoriasBusqueda = []
					return;
				}		
				categoriasFiltradas = self.categoriasList.filter(cat =>
					cat.nombre.toLowerCase().includes(texto.toLowerCase()) ||
					cat.codigo.toLowerCase().includes(texto.toLowerCase())
				);			

				if(categoriasFiltradas.length==0){
					Notifications.toast.error(
						"Busqueda de categorias",
						"No hay resultados para esta busqueda"
					)
				}
				self.categoriasBusqueda = categoriasFiltradas
			},
			buscarSubcategorias(texto){			
				let self=this;    
				let subcategoriasFiltradas = []           				
				if(texto.length==0){ 							
					self.subcategoriasBusqueda = self.subcategoriasList
					return;
				}
				if(texto.length>=1 && texto.length<3){
					self.subcategoriasBusqueda = []					
					return
				}
				subcategoriasFiltradas = self.subcategoriasList.filter(subcat =>
					subcat.nombre.toLowerCase().includes(texto.toLowerCase()) ||
					subcat.codigo.toLowerCase().includes(texto.toLowerCase())
				);		

				if(subcategoriasFiltradas.length==0){
					Notifications.toast.error(
						"Busqueda de subcategorias",
						"No hay resultados para esta busqueda"
					)
				}
				self.subcategoriasBusqueda = subcategoriasFiltradas
			},
			buscarProveedores(texto){				
				let self=this;   
				let proveedoresFiltrados = []            				
				if(texto.length==0){ 							
					self.proveedoresBusqueda = self.proveedoresList
					return;
				}

				if(texto.length>=1 && texto.length<3){ 
					self.proveedoresBusqueda = []
					return
				}
				proveedoresFiltrados = self.proveedoresList.filter(prov =>
					prov.nombre.toLowerCase().includes(texto.toLowerCase()) ||
					prov.codigo.toLowerCase().includes(texto.toLowerCase())
				);			

				if(proveedoresFiltrados.length==0){
					Notifications.toast.error(
						"Busqueda de proveedores",
						"No hay resultados para esta busqueda"
					)
				}
				self.proveedoresBusqueda = proveedoresFiltrados
			},

			agregarCategoria(cat){
				let self=this;   
				Notifications.alert.confirm(
					"Agregar Categoria",
					"¿Esta seguro(a) que desea agregar todos los productos de la categoría?",
					"Si",
					()=>{						
						let params= {
							categoria: cat.codigo,
							cuponera: this.cuponera
						}
						DynamicService.postActionList("cat", "cuponera-sku", "guardar_categoria_cuponera", params)
						.then((response)=>{   							
							if(response.status == 200){												
								cat.estado_agregado = 'A'								
								Notifications.toast.success(
									"Agregar Categoría",
									"Se agregaron los productos de la categoría al cupón"              
								)   
								self.$emit("refreshCuponeraSku",{page:1})             								
							}    						
						}).catch((error)=>{							
							if(error.response && error.response.data){
								Notifications.alert.error(
								"Agregar Categoría",
								error.response.data.error
								)
							}							
						})
					}
				);
			},
			agregarSubcategoria(subcat){
				//agrega una subcategoría al cupón
				let self=this;				       
					Notifications.alert.confirm(
					"Agregar Subcategoría",
					"¿Esta seguro(a) que desea agregar todos los productos de la subcategoría?",
					"Si",
					function(){
						let params={
						subcategoria : subcat.codigo,
						cuponera: self.cuponera,
						}
						DynamicService.postActionList("cat", "cuponera-sku","guardar_subcategoria_cuponera", params)
							.then((response)=>{   								
								if(response.status == 200){
									subcat.estado_agregado = 'A'
									Notifications.toast.success(
										"Agregar Subcategoria",
										"Subcategoria agregada exitosamente"
									)
									self.$emit("refreshCuponeraSku",{page:1})
								} 
							}).catch((error)=>{								
									Notifications.alert.error(
										"Error al guardar subcategorías",
										"Error "+error.response.data.error
									)
							})            
					}
				);
			}, 
			agregarProveedor(proveedor){
				//agrega una subcategoría al cupón
				let self=this;				  
					Notifications.alert.confirm(
					"Agregar Proveedor",
					"¿Esta seguro(a) que desea agregar todos los productos del Proveedor?",
					"Si",
					function(){
						let params={
						proveedor : proveedor.codigo,
						cuponera: self.cuponera,
						}
						DynamicService.postActionList("cat", "cuponera-sku","guardar_proveedor_cuponera", params)
							.then((response)=>{ 
								if(response.status == 200){									
									proveedor.estado_agregado = 'A'   
									Notifications.toast.success(
										"Agregar Proveedor",
										"Proveedor agregado exitosamente"
									)
									self.$emit("refreshCuponeraSku",{page:1})		
								}  								
							}).catch((error)=>{								
									Notifications.alert.error(
										"Error al guardar proveedor",
										"Error "+error.response.data.error
									)
							})            
					}
				);
			}, 
			abrirAcordeon(prov){
				let self= this;
				self.categoriasProveedor=[]				
				
				//Controla la expansion del acordeon
				//Si proveedorSeleccionado es el mismo que se esta intentando ver, retorna y no muestra listado
				if(self.proveedorSeleccionado.length > 0 && self.proveedorSeleccionado ==prov.codigo){
					self.proveedorSeleccionado = ""
					return
				}			
				//Si pasa validacion anterior (proveedorSeleccionado es diferente al que se esta intentado ver
				//se reasigna proveedorSeleccionado al prov.codigo actual y carga nuevas categorias para ser mostradas)
				self.proveedorSeleccionado = prov.codigo

				let params = {
					proveedor: prov.codigo,
					cuponera: self.cuponera
				}
				/*Busqueda de categorias por proveedor */
				DynamicService.getActionList("cat","proveedores","get_categorias_proveedor", params)
				.then((response)=>{					
					self.categoriasProveedor=response.data.sort((a,b)=>{
						if (a.codigo < b.codigo) return -1
						if (a.codigo > b.codigo) return 1						
						return 0							
					})
					self.proveedorExpandido = true
				}).catch((error)=>{					
					self.proveedorSeleccionado = ""
					Notifications.toast.error(
						"Proveedores", 
						error.response.data.error, 
						""
					)
				})
				/*Busqueda de subcategorias por proveedor */
				DynamicService.getActionList("cat","proveedores","get_subcategorias_proveedor", params)
				.then((response)=>{			
					self.subcategoriasProveedor=response.data.sort((a,b)=>{
						if (a.codigo < b.codigo) return -1
						if (a.codigo > b.codigo) return 1						
						return 0							
					})
					console.log("Respuesta de get_subcategorias_proveedor", self.subcategoriasProveedor)
				}).catch((error)=>{					
					Notifications.toast.error(
						"Proveedores", 
						error.response.data.error, 
						""
					)
				})				
			},
			agregarCategoriaProveedor(cat){
				let self=this;
				let params={
					cuponera: self.cuponera,
					proveedor: self.proveedorSeleccionado,
          categoria: cat.codigo
				}
				DynamicService.postActionList("cat","cuponera-sku","guardar_categoria_proveedor_cuponera", params) 
				.then((response)=>{					
					if(response.status == 200){	
						cat.estado_agregado='A'	
						Notifications.toast.success(
							"Agregar Categoría de Proveedor",
							"Categoria agregada exitosamente"
						)													
						self.$emit("refreshCuponeraSku",{page:1})	
					}						
				}).catch((error)=>{					
					Notifications.alert.error(
            "Proveedor - categorias", 
            error.response.data.error, 
            ""
          )
				})			
			},
			agregarSubcategoriaProveedor(subcat){
				let self=this;			      
				let params={
					cuponera: self.cuponera,
					proveedor: self.proveedorSeleccionado,
          subcategoria: subcat.codigo
				}
				DynamicService.postActionList("cat","cuponera-sku","guardar_subcategoria_proveedor_cuponera", params) 
				.then((response)=>{					
					if(response.status == 200){	
						subcat.estado_agregado='A'	
						console.log("Cambiando estado a subcategoria", subcat)
						Notifications.toast.success(
							"Agregar Subcategoría de Proveedor",
							"Subcategoria agregada exitosamente"
						)													
						self.$emit("refreshCuponeraSku",{page:1})		
					}
				}).catch((error)=>{					
					Notifications.alert.error(
            "Proveedor - subcategorias", 
            error.response.data.error, 
            ""
          )
				})
			},
			limpiarInput(){
				let self=this;				
				self.proveedorSeleccionado = ""
        self.categoriasProveedor = []
				self.subcategoriasProveedor = []
				self.categoriasBusqueda= []
				self.searchQuery = ""
				self.subcategoriasBusqueda = []
				self.subcategoriasBusqueda = self.subcategoriasList
				self.searchQuerySubcategoria= ""
			}
		},
	 }
</script>
<style>	
	.nav-tabs .nav-link.active {
		background-color: #e8f0ff;
		border-color: #dee2e6 #dee2e6 #fff;
		font-weight: bold;
	}

	.no-hover:hover {
    background-color: inherit !important;
	}

</style>